export const features = [
  {
    title: "Shiatsu technika",
    description:
      "Ebben a rohanó világban a shiatsu egy olyan természetes módszert kínál, amely segít újra kapcsolódni önmagunkkal és megtalálni a belső harmóniát.",
    href: "/shiatsu-technika",
    color: "shiatsu",
  },
  {
    title: "Kronobiológia",
    description:
      "Lehetőség nyílik az egyéni képességek fejlesztésére, a kapcsolatok harmonizálására és a tudatosabb életvitel kialakítására.",
    href: "/kronobiologia",
    color: "chrono",
  },
  {
    title: "Bowen kezelés",
    description:
      "Hát-, derék-, váll-, ízületi fájdalom, állkapocs probléma, emésztőrendszeri eltérések, neurológiai állapotok alternatív kezelésére.",
    href: "/bowen-kezeles",
    color: "bowen",
  },
  {
    title: "Indiai fejmasszázs",
    description:
      "Speciális lelki blokkoló technika, feloldja a lelki megakadást, szorongást, depressziót, gátakat, pánikbetegséget, az energiaáramlást segíti.",
    href: "/indiai-fejmasszazs",
    color: "head-massage",
  },
  {
    title: "Metamorf érintés",
    description:
      "Nyugodtabb alvást, megnövekedett energiát és életerőt eredményezhet.",
    href: "metamorf-erintes",
    color: "metamorf",
  },
];

export const intro = (
  <>
    35 éves egészségügyi és oktatói tapasztalattal keresem azokat a módszereket,
    melyek a szervezet <b>öngyógyító</b> folyamataival tudják részben vagy
    egészben segíteni, kiváltani az egészségügyi kezeléseket.
  </>
);
